import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React, { ButtonHTMLAttributes, forwardRef } from "react";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & StyledButtonProps;

type StyledButtonProps = {
  fluid?: boolean;
  testId?: string;
};

const StyledButton = styled.button<StyledButtonProps>`
  background: linear-gradient(90deg, #e5258c 0%, #863bd4 96.36%);
  height: 3rem;
  padding: 0.5rem 1rem; 
  font-size: 1rem;
  font-weight: 600;
  color: white;
  border: 0;
  border-radius: 1.5rem;
  outline: 0;
  cursor: pointer;
  min-width: 10rem;

  &:focus {
    box-shadow: 0 0 0 0.25rem #f2d0e2;
  }

  &:disabled {
    pointer-events: none;
    background: #e1e1e1;
  }

  ${(props) =>
    props.fluid &&
    css`
      width: 100%;
    `}
`;

const Button = forwardRef<HTMLButtonElement, Props>((props: Props, ref) => {
  const { fluid, testId, ...buttonProps } = props;

  return <StyledButton ref={ref} fluid={fluid} data-testid={testId} {...buttonProps} />;
});

export default Button;
